import { render, staticRenderFns } from "./formedModalUpdate.vue?vue&type=template&id=1b830b2b&scoped=true&"
import script from "./formedModalUpdate.vue?vue&type=script&lang=js&"
export * from "./formedModalUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b830b2b",
  null
  
)

export default component.exports